import React, { PropsWithChildren } from 'react'
import ModalHeader, { ModalHeaderProps } from 'components/Luxkit/Modal/ModalHeader'

import { isHeadlessModeSel, isIOSSel } from 'selectors/configSelectors'
import { useAppSelector } from 'hooks/reduxHooks'

export const ModalHeaderWrapper = (props: PropsWithChildren<ModalHeaderProps>) => {
  // Use web modals on iOS , hide back and close buttons.
  const isIOS = useAppSelector(isIOSSel)
  const isHeadless = useAppSelector(isHeadlessModeSel)
  const {
    onBackButtonClick,
    onCloseButtonClick,
    ...rest
  } = props
  if (isIOS && isHeadless) return <ModalHeader {...rest} />
  return <ModalHeader onBackButtonClick={onBackButtonClick} onCloseButtonClick={onCloseButtonClick} {...rest} />
}
